import formatNumber from "./formatNumber";

const formatRange = (unit: string, min?: string, max?: string): string => {
  if (max && min)
    return `${formatNumber(Number(min))} - ${formatNumber(Number(max))}${unit}`;

  if (max) {
    return ` - ${formatNumber(Number(max))}${unit}`;
  } else if (min) {
    return `${formatNumber(Number(min))}${unit} - `;
  }

  return "指定なし";
};
export default formatRange;
